import * as React from 'react';
import { useQuery, useQueryClient } from 'react-query';

import { SOURCE_API_ROUTES } from '@/api-routes';
import { axiosInstance } from '@/axios';

export type PublicSourceFeed = {
  id: string;
  name: string;
  connected: boolean;
};

const QUERY_KEY = 'website_feeds';

export const useFetchPublicSourceFeeds = (sourceId: string) => {
  return useQuery(
    [QUERY_KEY, sourceId],
    ({ signal }) =>
      axiosInstance.get<{ results: PublicSourceFeed[] }>(
        SOURCE_API_ROUTES.publicSourceBoards(sourceId),
        { signal }
      ),
    {
      staleTime: Infinity,
      enabled: false,
      select: (data) => data.data.results,
    }
  );
};

export const useRefetchAllPublicSourcesFeeds = () => {
  const queryClient = useQueryClient();

  return React.useCallback(() => {
    return queryClient.invalidateQueries([QUERY_KEY], {
      refetchInactive: true,
    });
  }, [queryClient]);
};

export const useRefetchPublicSourceFeeds = () => {
  const queryClient = useQueryClient();

  return React.useCallback(
    async (sourceId: string) => {
      await queryClient.invalidateQueries([QUERY_KEY, sourceId], {
        refetchInactive: true,
      });
    },
    [queryClient]
  );
};
